import { createContext } from "react";

const AnalyticsContext = createContext({
	store: {},
});

export default AnalyticsContext;
